import { useState, useEffect } from 'react';

type Particle = { id: number; x: number; y: number; delay: number; duration: number };

function createParticles(): Particle[] {
  return Array.from({ length: 20 }, (_, id) => ({
    id,
    x: (id * 37) % 100,
    y: (id * 61) % 100,
    delay: ((id * 37) % 200) / 100,
    duration: 2 + ((id * 61) % 300) / 100,
  }));
}

export function useOrbitalAnimation() {
  const [rotation, setRotation] = useState(0);
  const [particles] = useState<Particle[]>(createParticles);

  useEffect(() => {
    let raf: number;
    const animate = () => {
      setRotation((r) => (r + 0.2) % 360);
      raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, []);

  return { rotation, particles };
}
